// SX-02 (student-foundation-redesign, doc 22 §3): the ONE piece of state
// behind the shared Student "Coming Soon" dialog. Every gated entry point --
// the Home teacher card, the register-as-teacher card, the Profile
// become-volunteer CTA, the `/help/request` and new-session route guards, and
// (SX-03B) an unavailable course tile -- raises the SAME dialog instance,
// which `App/index.vue` renders once at the shell root.
//
// Same shape and reasons as `app/logoutConfirm`: a store module rather than a
// local `v-if` because router guards have no component context, and rather
// than the legacy `app/modal` because that renders `ModalTemplate`'s
// full-screen slide-up chrome, not the V2 sheet.
//
// Copy lives in the locale files, keyed by `variant` + `reason`, and is
// resolved inside the component -- nothing here is user-visible text.
//
// V405-C (doc 26 §7): a third variant, `advisor`, raised by the Home Advisor
// card. It is the same dialog instance; its teacher action is resolved by
// `continueWithTeacher` below.
const TEACHER_CAPABILITY = 'featureFlags/isStudentTeacherExperienceAvailable'

const DEFAULT_DIALOG = {
  variant: 'teacher', // 'teacher' | 'course' | 'advisor'
  reason: 'help', // teacher only: 'help' | 'register'
  courseLabel: null, // course only: the course displayName
}

export default {
  namespaced: true,
  state: {
    isShown: false,
    ...DEFAULT_DIALOG,
  },
  mutations: {
    setDialog: (state, { variant, reason, courseLabel }) => {
      state.isShown = true
      state.variant = variant
      state.reason = reason
      state.courseLabel = courseLabel
    },
    clear: state => {
      state.isShown = false
      state.variant = DEFAULT_DIALOG.variant
      state.reason = DEFAULT_DIALOG.reason
      state.courseLabel = DEFAULT_DIALOG.courseLabel
    },
  },
  actions: {
    // `show` also dismisses the logout confirmation: two shell-root dialogs
    // must never be active at once (doc 22 §3).
    show: ({ commit, dispatch }, payload = {}) => {
      dispatch('app/logoutConfirm/hide', null, { root: true })
      commit('setDialog', {
        variant: payload.variant || DEFAULT_DIALOG.variant,
        reason: payload.reason || DEFAULT_DIALOG.reason,
        courseLabel:
          payload.courseLabel === undefined
            ? DEFAULT_DIALOG.courseLabel
            : payload.courseLabel,
      })
    },
    hide: ({ commit }) => commit('clear'),
    // V405-C: the Advisor popup's «ادامه با معلم» is the Home teacher card's
    // own path, decided by the same central capability (doc 22 §4). ON: the
    // popup closes and the caller navigates to the existing request flow
    // (resolves `true`). OFF: the popup is replaced by the existing teacher
    // Coming Soon dialog and nothing navigates (resolves `false`).
    continueWithTeacher: ({ dispatch, rootGetters }) => {
      if (rootGetters[TEACHER_CAPABILITY] === true) {
        dispatch('hide')
        return true
      }
      dispatch('show', { variant: 'teacher', reason: 'help' })
      return false
    },
  },
}
